(() => {
  const responsiveImage = (image, source, deferred = false) => {
    if (!image || !source) return;
    const url = new URL(source, window.location.origin);
    const srcset = [240, 360, 540, 720].map(width => {
      const candidate = new URL(url);
      candidate.searchParams.set('width', width);
      return `${candidate.href} ${width}w`;
    }).join(', ');
    if (deferred) {
      image.dataset.srcset = srcset;
      image.dataset.src = url.href;
      if (!image.hasAttribute('src')) return;
    }
    image.srcset = srcset;
    image.src = url.href;
  };
  const loadHover = card => {
    const image = card?.querySelector('.aig-card__folded');
    if (!image?.dataset.src) return;
    image.srcset = image.dataset.srcset || '';
    image.src = image.dataset.src;
  };
  document.addEventListener('pointerover', event => {
    if (event.pointerType === 'mouse') loadHover(event.target.closest('.aig-card'));
  });
  document.addEventListener('focusin', event => loadHover(event.target.closest('.aig-card')));
  const initCatalog = root => {
    if (root.dataset.ready) return;
    root.dataset.ready = 'true';
    const grid = root.querySelector('[data-product-grid]');
    const cards = Array.from(grid.querySelectorAll('.aig-card'));
    const size = root.querySelector('[data-filter-size]');
    const color = root.querySelector('[data-filter-color]');
    const sort = root.querySelector('[data-filter-sort]');
    let vibe = root.dataset.initialVibe || 'all';
    const priority = ['ai-is-going-to-kill-you-retro-prophecy-graphic-t-shirt','ai-life-guard','mushroom-monitors','hang-loosely','ai-is-going-to-kill-you-editorial-warning-graphic-t-shirt','the-company-man-allen-graphic-t-shirt','the-third-option','this-is-probably-fine-ai-is-going-to-kill-you'];
    cards.sort((a,b)=>(priority.includes(a.dataset.handle)?priority.indexOf(a.dataset.handle):99)-(priority.includes(b.dataset.handle)?priority.indexOf(b.dataset.handle):99));
    const rows = cards.map((card, index) => ({card, index, variants: JSON.parse(card.dataset.variants || '[]')}));
    Array.from(new Set(rows.flatMap(row => row.variants.map(v => v.color)))).sort().forEach(name => color.add(new Option(name, name)));
    const update = () => {
      const ordered = [...rows];
      if (sort?.value === 'az' || sort?.value === 'za') ordered.sort((a,b) => a.card.dataset.title.localeCompare(b.card.dataset.title) * (sort?.value === 'za' ? -1 : 1));
      else if (sort?.value === 'newest') ordered.sort((a,b) => Number(b.card.dataset.created) - Number(a.card.dataset.created));
      else ordered.sort((a,b) => a.index-b.index);
      let count = 0;
      const home = root.hasAttribute('data-home-grid') && vibe === 'all' && !size.value && !color.value && sort?.value === 'featured';
      ordered.forEach(row => {
        const match = (vibe === 'all' || row.card.dataset.category === vibe) && row.variants.some(v => v.available && (!size.value || v.size === size.value) && (!color.value || v.color === color.value));
        row.card.hidden = !match || (home && count >= 8);
        if (match) count++;
        grid.appendChild(row.card);
      });
      root.querySelectorAll('[data-vibe]').forEach(button => button.setAttribute('aria-pressed', String(button.dataset.vibe === vibe)));
      root.querySelector('.aig-filter-empty').hidden = count > 0;
      root.querySelector('[data-filter-status]').textContent = count + ' tees';
    };
    root.querySelectorAll('[data-vibe]').forEach(button => button.addEventListener('click', () => {vibe = button.dataset.vibe; update();}));
    [size,color,sort].filter(Boolean).forEach(select => select.addEventListener('change',update));
    root.querySelector('[data-reset-filters]').addEventListener('click',()=>{vibe='all';size.value='';color.value='';if(sort)sort.value='featured';update();});
    update();
  };
  const init = () => document.querySelectorAll('[data-aig-catalog]').forEach(initCatalog);
  document.addEventListener('click', event => {
    const arrow = event.target.closest('[data-gallery-step]');
    if (arrow) {
      const gallery = arrow.closest('media-gallery');
      const thumbnails = Array.from(gallery.querySelectorAll('.thumbnail-list__item button'));
      const active = thumbnails.findIndex(item => item.getAttribute('aria-current') === 'true');
      const next = (Math.max(0,active) + Number(arrow.dataset.galleryStep) + thumbnails.length) % thumbnails.length;
      thumbnails[next]?.click();
    }
    const pause = event.target.closest('[data-announcement-pause]');
    if (pause) {
      const banner = pause.closest('.aig-announcement');
      const paused = banner.classList.toggle('is-paused');
      pause.setAttribute('aria-pressed',String(paused));
      pause.querySelector('[aria-hidden]').textContent = paused ? '▶' : 'Ⅱ';
    }
    const button = event.target.closest('.aig-card .aig-swatch');
    if (button) {
      const card = button.closest('.aig-card');
      card.querySelectorAll('.aig-swatch').forEach(swatch=>swatch.setAttribute('aria-pressed',String(swatch===button)));
      const front = card.querySelector('.aig-card__front');
      const folded = card.querySelector('.aig-card__folded');
      responsiveImage(front, button.dataset.front);
      responsiveImage(folded, button.dataset.folded, true);
      card.querySelectorAll('a').forEach(link=>link.href=button.dataset.url);
    }
    document.querySelectorAll('.aig-vibe-menu[open],.aig-mobile-nav[open]').forEach(menu=>{if(!menu.contains(event.target))menu.open=false;});
  });
  document.addEventListener('keydown',event=>{if(event.key==='Escape')document.querySelectorAll('.aig-vibe-menu[open],.aig-mobile-nav[open]').forEach(menu=>{menu.open=false;menu.querySelector('summary').focus();});});
  document.addEventListener('change',event=>{const input=event.target.closest('input[data-option-name="Color"]');if(input){const label=input.closest('fieldset')?.querySelector('[data-selected-color]');if(label)label.textContent=input.value;}});
  document.addEventListener('shopify:section:load',init);
  init();
  const initialColors = {"hippopotomonstrosesquippedalio":"Black","pneumonoultramicroscopicsilicovolcanoconiosis":"Black","black-cat-path":"Black","kool-doom":"White","kool-doom-back":"White","ai-is-going-to-kill-you-glitch":"Black","aig2ky-red-label-ii":"White","aig2ky-red-label-i":"White","mark-zuckerberg-devil-shirt":"Black","elon-musk-devil-shirt":"Black","dario-amodei-shirt":"Black","sam-altman-shirt":"Black","allen-camel":"Black","aig2ky-tie-dye":"Lagoon Blue","aig2ky-white":"Black","aig2ky-black":"Ivory","aig2ky-multicolor":"Butter","steal-your-job":"Black","the-greatest-show-on-earth":"Mustard","wave-of-mutilation":"Island Reef","get-a-grip-bro":"Watermelon","ai-life-guard":"Grape","mushroom-monitors":"Black","hang-loosely":"Black","behind-the-curtain":"Midnight","shark-machina":"Island Green","wah-wah-wah-wah":"Black","lemmings":"Bright Orange","the-third-option":"Black","spf-404-single-point-of-failure":"Lagoon Blue","the-phases-of-doom":"Berry","i-repeat-ai-is-going-to-kill-you":"Black","this-is-probably-fine-ai-is-going-to-kill-you":"Blue Jean","i-said-please-remember-that-ai-is-going-to-kill-you":"Blue Jean","ai-is-going-to-kill-you-editorial-warning-graphic-t-shirt":"Blue Spruce","ai-is-going-to-kill-you-retro-prophecy-graphic-t-shirt":"Ivory","famous-last-prompt-system-warning-graphic-t-shirt":"Bay","copy-of-the-company-man-allen-graphic-t-shirt":"Black","the-company-man-allen-graphic-t-shirt":"White","the-four-horsemen-of-the-apocalypse":"Black"};
  document.querySelectorAll('.aig-card').forEach(card => {
    const name = initialColors[card.dataset.handle];
    const buttons = Array.from(card.querySelectorAll('.aig-swatch'));
    const swatch = buttons.find(button => button.getAttribute('aria-label')===name && !button.disabled) || buttons.find(button => button.getAttribute('aria-pressed')==='true');
    if (swatch) swatch.click();
  });
})();

(() => {
  const excluded = new Set(["with_pictures", "pictures_first", "videos_first", "most_helpful"]);
  const connect = () => {
    const widget = document.getElementById("judgeme_product_reviews");
    if (!widget) return false;
    const update = () => {
      widget.querySelectorAll("select.jdgm-sort-dropdown").forEach(select => {
        const reset = excluded.has(select.value);
        if (reset) select.value = "created_at";
        Array.from(select.options).forEach(option => {
          if (excluded.has(option.value)) option.remove();
        });
        if (reset) select.dispatchEvent(new Event("change", { bubbles: true }));
      });
    };
    update();
    new MutationObserver(update).observe(widget, { childList: true, subtree: true });
    return true;
  };
  const start = () => {
    if (connect()) return;
    const waiting = new MutationObserver(() => { if (connect()) waiting.disconnect(); });
    waiting.observe(document.body, { childList: true, subtree: true });
  };
  if (document.readyState === "loading") document.addEventListener("DOMContentLoaded", start, { once: true });
  else start();
})();
